import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import ListPageCardHeader from "components/Card/ListPageCardHeader";
import SearchTable2 from "components/Tables/SearchTable2";
import Loading from "components/Loading/Loading";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { getEmptyPageResponse, toTablePageableData } from "utils";
import { parametersService } from "services/parametersService";
import { ROUTES } from "constants/routes-path";

function ParametersList() {
  const { t} = useTranslation();
  const [searchParams, setSearchParams] = useState({});
  const [response, setResponse] = useState(undefined);
  const showToast = useCustomToast();
  const navigate = useNavigate();

  const columns = useMemo(() => [
    { Header: t("settings.parameter.list.table.header.code"), accessor: "codigo" },
    { Header: t("settings.parameter.list.table.header.description"), accessor: "descricao" },
    { Header: t("settings.parameter.list.table.header.value"), accessor: "valor" },
    {
      Header: t("system.labels.actions"),
      disableSortBy: true,
      actions: [
        {
          label: t("system.actions.edit"),
          icon: <FaEdit />,
          onClick: ({ original }) => navigate(ROUTES.parametersEditPath.replace(":id", original.id)),
        }
      ]
    },
  ], []);

  const fetchData = async (params = {}) => {
    if (response) setResponse(undefined);

    try {
      params = { ...searchParams, ...params };
      setSearchParams(params);
      const data = await parametersService.list(params);
      setResponse(data);
    } catch (err) {
      setResponse(getEmptyPageResponse(searchParams));
      showToast({ title: t(err), status: "error" });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Flex gap="5" direction="column" pt={{ base: "150px", lg: "90px" }}>
      <Card overflowX={{ sm: "scroll", lg: "hidden" }}>
        <ListPageCardHeader title={t("settings.parameter.title")} subtitle={t("settings.parameter.description")} />

        <CardBody>
          {response ? (
            <SearchTable2
              columnsData={columns}
              tableData={response.content}
              pageableData={toTablePageableData(response, { defaultField: "codigo", ...searchParams })}
              onChange={fetchData}
              truncatedColumns={[t("settings.parameter.list.table.header.value")]}
              noOfLines={1}
            />
          ) : (
            <Loading maxH={{ sm: "100px", md: "350px" }} />
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}

export default ParametersList;